export default __webpack_public_path__ + "static/media/7TwJ.e3a9b9c8.gif";